import React from "react";
import classes from "./UserLandingPage.module.css";
import DateRangeIcon from "@mui/icons-material/DateRange";
const ProgressCard = ({ programDetails, handleClick, activeCard }) => {
  // console.log("programDetails", programDetails);

  return (
    <>
      <div
        className={classes.progressCardCon}
        onClick={() => {
          handleClick(programDetails?.userGroupId, programDetails);
        }}
        style={{ border: activeCard ? "2px solid #224B99" : "" }}
      >
        <p className={classes.title}>{programDetails?.userGroupName}</p>
        <p className={classes.courseParticipant}>
          Course Participants: {programDetails?.totalUsers}
        </p>
        <p className={classes.course}>
          Courses: {programDetails?.totalCourses}
        </p>
        <div className={classes.progressMainCon}>
          <div className={classes.progressCon}>
            <div className={classes.total}></div>
            <div
              className={classes.progressAmount}
              style={{
                width: `${Number(programDetails?.completionPercentage)}%`,
              }}
            ></div>
          </div>
          <div className={classes.percentage}>
            {programDetails?.completionPercentage}%
          </div>
        </div>
        <div className={classes.dateCon}>
          <div>
            <DateRangeIcon />
          </div>
          <p className={classes.date}>
            {new Date(programDetails.startDate?.$date).toDateString()} -{" "}
            {new Date(programDetails.endDate.$date).toDateString()}
          </p>
        </div>
      </div>
    </>
  );
};

export default ProgressCard;
